import * as z from 'zod/mini';
import { ScalarMeasurementKind } from '../measurements/ScalarMeasurementKind.js';
import { UnitToken } from '../measurements/UnitToken.js';
import { defineFormInput } from './defineFormInput.js';
/**
 * Unified input for any patient-reportable scalar measurement (height, weight, ...). The `kind`
 * selects the {@link SCALAR_MEASUREMENTS} definition that drives the offered units, label and step, so a
 * single input type replaces the former per-measurement `HEIGHT`/`WEIGHT` inputs. The answer value
 * (`{ value, unit }`) mirrors {@link PatientMeasurementInput}: `unit` stays a loose string at the wire
 * boundary and is validated against the kind at ingest.
 */
export const MeasurementInput = defineFormInput({
    type: 'MEASUREMENT',
    input: {
        kind: ScalarMeasurementKind,
        question: z.string(),
        help: z.optional(z.string()),
    },
    value: {
        kind: ScalarMeasurementKind,
        value: z.number(),
        unit: UnitToken,
    },
});
//# sourceMappingURL=MeasurementInput.js.map